import { useRuntimeConfig } from '#imports'

import { useExperiments } from '@backmarket/nuxt-module-experiments/useExperiments'
import { useMarketplace } from '@backmarket/nuxt-module-marketplace/useMarketplace'

type VertexAiSearchResult =
  | { enabled: false; hostUrl: undefined; protocol: undefined }
  | { enabled: true; hostUrl: string; protocol: string }

export function useVertexAiSearch(
  feature: string | undefined,
): VertexAiSearchResult {
  if (!feature) {
    return { enabled: false, hostUrl: undefined, protocol: undefined }
  }

  const experiments = useExperiments()

  const isVertexAiSearchEnabled =
    experiments['experiment.vertexAiSearch'] === 'withVertexAiSearch' ||
    experiments['experiment.vertexAiSearchQa'] === 'withVertexAiSearchQa'

  if (!isVertexAiSearchEnabled) {
    return { enabled: false, hostUrl: undefined, protocol: undefined }
  }

  const { market } = useMarketplace()
  const http2Config = useRuntimeConfig().public.http2

  const baseUrl = import.meta.server
    ? http2Config.baseUrlServer
    : http2Config.baseUrlClient || window.location.origin

  if (!baseUrl) {
    return { enabled: false, hostUrl: undefined, protocol: undefined }
  }

  const resolvedBaseUrl = baseUrl.replace('{market.domain}', market.domain)
  const protocol = resolvedBaseUrl.startsWith('http://') ? 'http' : 'https'
  const hostUrl = `${resolvedBaseUrl.replace(`${protocol}://`, '')}/api/search-vertex-ai`

  return { enabled: true, hostUrl, protocol }
}
